import gsap from 'gsap';
import BaseComponent from './BaseComponent';
import Menu from './Menu';
import Nav from './Nav';
import SearchPopup from './SearchPopup';
import throttle from 'lodash.throttle';

export default class PageHeader extends BaseComponent {
	constructor() {
		super();

		this.initialNamespace = document.querySelector('[data-barba="container"]').getAttribute('data-barba-namespace');

		this.isMobile = window.matchMedia('(max-width: 991px)');
		this.isHovered = false;
		this.isMinimized = false;
		this.wasTransitioned = false;
		this.isTransitioning = false;

		// Elements
		this.elm = document.querySelector('[data-page-header]');
		this.blur = this.elm.querySelector('[data-blur]');
		this.container = this.elm.querySelector('[data-page-header-container]');
		this.logo = this.elm.querySelector('[data-page-header-logo]');

		// Components
		this.menu = new Menu(this.elm.querySelector('[data-menu]'), this);
		this.initNav();
		this.initSearch();

		document.addEventListener('update-header', () => {
			this.initNav();
			this.initSearch();
		});

		// Event Listeners
		this.elm.addEventListener('mouseenter', () => {
			if (this.isMobile.matches) return;
			if (!this.isRevealed) return;
			this.isHovered = true;
			this.maximize();
			this.showBar();
		});
		this.elm.addEventListener('mouseleave', () => {
			if (this.isMobile.matches) return;
			if (!this.isRevealed) return;
			this.isHovered = false;
		});

		document.addEventListener('close-menu', () => {
			this.menu.close();
		});

		document.addEventListener('show-header', () => {
			this.show();
		});

		document.addEventListener('hide-header', () => {
			this.hide();
		});

		document.addEventListener('show-logo', () => {
			this.logo.classList.remove('is-hidden');
		});

		document.addEventListener('hide-logo', () => {
			this.logo.classList.add('is-hidden');
		});

		document.addEventListener('hide-logo-mobile', () => {
			this.elm.classList.add('hide-logo-mobile');
		});

		document.addEventListener('show-logo-mobile', () => {
			this.elm.classList.remove('hide-logo-mobile');
		});

		document.addEventListener('transition-start', () => {
			if (!this.isMobile.matches) {
				this.isHovered = false;
				this.isTransitioning = true;
				this.hideBar();
				this.minimize();
				this.nav.closeMenus();
			}
		});

		document.addEventListener('transition-end', () => {
			this.isTransitioning = false;
			this.wasTransitioned = true;
			if (this.isMobile.matches) {
				this.maximize();
			}
		});

		this.blur.addEventListener('click', () => {
			this.menu.close();
		});

		// State
		this.isMobile.addEventListener('change', (e) => {
			// update States?
		});

		// Scroll Listener
		document.addEventListener(
			'scroll',
			throttle((e) => this.checkScroll(), 100)
		);
		this.prevScroll = 0;
		this.checkScroll();

		this.isRevealed = false;

		this.setInitialState();

		if (this.initialNamespace != 'template-home') {
			this.reveal(true);
		}

		document.addEventListener('reveal-header', () => {
			this.reveal();
		});
	}

	setInitialState() {
		gsap.set(this.container, {
			autoAlpha: 0,
		});
	}

	initNav() {
		this.nav = new Nav(this.elm.querySelector('[data-nav]'), this);
	}

	initSearch() {
		if (this.searchPopup) {
			this.searchPopup.destroy();
		}
		this.searchPopupElm = this.elm.querySelector('[data-search-popup-wrapper]');
		this.searchPopup = new SearchPopup(this.searchPopupElm);
	}

	checkScroll() {
		if (this.isTransitioning) return;
		window.scrollY > 60 ? this.checkState() : this.setTopState();
		this.prevScroll = window.scrollY;
	}

	setTopState() {
		if (this.wasTransitioned) return;
		this.maximize();
		this.elm.classList.remove('is-scrolled-up');
	}

	checkState() {
		this.wasTransitioned = false;
		if (this.prevScroll > window.scrollY) {
			this.maximize();
			this.elm.classList.add('is-scrolled-up');
		} else {
			this.minimize();
			this.hideBar();
			this.elm.classList.remove('is-scrolled-up');
		}
	}

	minimize(instant = false) {
		if (this.isHovered) return;
		if (this.isMinimized) return;
		this.isMinimized = true;
		this.elm.classList.add('is-minimized');
	}

	maximize() {
		if (this.isTransitioning) return;
		if (!this.isMinimized) return;
		if (!this.isRevealed) return;
		this.isMinimized = false;
		this.elm.classList.remove('is-minimized');
	}

	reveal(instant = false) {

		setTimeout(() => {
			this.elm.classList.remove('is-minimized');
			this.elm.classList.add('is-revealed');
		}, 0);

		gsap.to(this.container, {
			autoAlpha: 1,
			duration: instant ? 0 : 2,
			delay: instant ? 0 : 2,
			ease: 'sine.inOut',
			clearProps: 'opacity, visibility',
			onComplete: () => {
				this.isMinimized = false;
				this.isRevealed = true;
			},
		});
	}

	showBar() {
		this.elm.classList.add('show-bar');
	}

	hideBar() {
		this.elm.classList.remove('show-bar');
		this.elm.classList.remove('is-scrolled-up');
	}

	showBlur() {
		this.elm.classList.add('show-blur');
		this.blur.removeAttribute('inert');
	}

	hideBlur() {
		this.elm.classList.remove('show-blur');
		this.blur.setAttribute('inert', '');
	}

	show() {
		gsap.to(this.elm, {
			autoAlpha: 1,
			duration: 0.4,
			delay: 0.4,
			ease: 'none',
			overwrite: true,
		});
	}

	hide() {
		gsap.to(this.elm, {
			autoAlpha: 0,
			duration: 0.4,
			ease: 'none',
			overwrite: true,
		});
	}
}

export const pageHeader = new PageHeader();
